<template>
	<section class="marketing-section bg-color-greige">
		<div class="container display-flex gap-300 flex-direction-column">
			<h2 class="heading-2 text-align-center"> Important details </h2>
			<div class="faq-section col-10-md col-6-lg ml-auto mr-auto">
				<QuestionList :question-items="ipoTopQuestions" />
			</div>
			<p class="text-align-center body-sm muted">
				View our
				<BaseLink classes="text-color-current-color text-decoration-underline" :link="fullDisclosureLink" />.
			</p>
		</div>
	</section>
</template>

<script setup lang="ts">
import { ipoTopQuestions } from '@constants/offerings';
import { Link } from 'types/layout';
import QuestionList from '@components/layout/question-list.vue';

const fullDisclosureLink: Link = {
	hash: '#rise-companies-disclosure',
	router: 'disclosures',
	target: '_blank',
	text: 'full disclosure'
};
</script>
<style lang="scss">
@use '../../../styles/utilities/respond-to.scss' as *;

.faq-section {
	@include respond-to(md) {
		max-width: 50%;
		margin: 0 auto;
	}
}
</style>
